import { mutate } from "swr";

export const mutateMultipleSWRRequestKeys = (requestKeys: string[]) =>
  mutate((key: string) => requestKeys.includes(key));
